import createClient, { Middleware } from "openapi-fetch";
import type { paths } from "./lib/api/v1";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const middleware: Middleware = {
  async onRequest({ request }) {
    const accessToken = localStorage.getItem("access_token");

    if (accessToken === null) {
      console.error("No token found in local storage");
      return request;
    }

    request.headers.set("Authorization", `Bearer ${accessToken}`);

    return request;
  },
  async onResponse({ response }) {
    if (!response.ok) {
      throw new Error(
        `Error in request: ${response.status} - ${response.statusText}`
      );
    }
  }
};

export function createApiClient() {
  const baseClient = createClient<paths>({ baseUrl: API_BASE_URL });
  baseClient.use(middleware);

  return baseClient;
}
